<template lang="html">
  <div class="contact-container">
    <svg version="1.1" id="Layer_4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    	 width="307.968px" height="50.507px" viewBox="0 0 307.968 50.507" enable-background="new 0 0 307.968 50.507"
    	 xml:space="preserve">
    <g>
    	<path class="contact-path" d="M26.485,49.819c-12.681,0-22.956-10.32-21.209-23.238C7.029,13.616,20.051,3.185,32.791,3.185
    		c9.583,0,12.563,2.146,12.681,2.232c0.207,0.154,0.271,0.443,0.184,0.689l-3.445,9.805c-0.022,0.062-0.279,0.881-1.024,0.441
    		c0,0-3.42-2.039-8.363-2.039c-9.643,0-14.653,6.662-15.396,12.162C16.675,32.03,19.885,38.69,29.527,38.69
    		c4.942,0,8.914-2.039,8.914-2.039c0.061-0.031,0.833-0.454,0.905,0.441l0.794,9.805c0.022,0.271-0.152,0.547-0.362,0.684
    		C39.588,47.698,36.033,49.819,26.485,49.819z M38.08,38.194c-1.49,0.623-4.831,1.82-8.732,1.82c-10.39,0-14.085-7.33-13.246-13.539
    		c0.833-6.158,6.511-13.487,16.9-13.487c3.888,0,6.838,1.161,8.24,1.821l2.986-8.498c-0.955-0.488-4.218-1.803-11.617-1.803
    		c-12.062,0-24.367,9.919-26.01,22.072C4.966,38.677,14.65,48.494,26.665,48.494c7.366,0,10.964-1.29,12.104-1.803L38.08,38.194z"/>
    	<path class="contact-path" d="M73.626,3.185c12.683,0,21.215,10.652,19.506,23.291c-1.708,12.637-13.126,23.344-25.811,23.344
    		c-12.683,0-21.26-10.704-19.551-23.344C49.479,13.834,60.946,3.185,73.626,3.185z M67.5,48.494
    		c11.905,0,22.691-10.067,24.307-22.019c1.616-11.95-6.454-21.967-18.36-21.967c-11.908,0-22.738,10.019-24.353,21.967
    		C47.479,38.425,55.595,48.494,67.5,48.494z M72.251,13.359c7.171,0,11.935,5.99,10.972,13.116
    		c-0.963,7.123-7.35,13.169-14.525,13.169c-7.173,0-11.981-6.042-11.018-13.169C58.644,19.346,65.082,13.359,72.251,13.359z
    		 M68.876,38.319c6.391,0,12.15-5.4,13.021-11.844c0.871-6.441-3.431-11.791-9.826-11.791c-6.397,0-12.197,5.354-13.067,11.791
    		C58.134,32.915,62.482,38.319,68.876,38.319z"/>
    	<path class="contact-path" d="M101.919,4.642c0,0,0.25-1.348,1.153-0.511l23.343,21.636l2.956-21.128c0.053-0.378,0.426-0.659,0.752-0.659h9.962
    		c0.401,0,0.611,0.378,0.573,0.662l-5.911,43.721c0,0-0.246,1.346-1.151,0.512L110.145,27.29l-2.849,21.072
    		c-0.054,0.4-0.467,0.662-0.752,0.662h-9.963c-0.401,0-0.611-0.379-0.573-0.662L101.919,4.642z M106.061,47.699l2.948-21.807
    		c0.178-1.316,1.151-0.513,1.151-0.513l23.45,21.584l5.633-41.66h-8.641l-3.059,21.863c-0.184,1.316-1.152,0.509-1.152,0.509
    		l-23.337-21.63l-5.632,41.653H106.061z"/>
    	<path class="contact-path" d="M146.014,4.642c0.055-0.4,0.468-0.662,0.752-0.662h30.736c0.401,0,0.611,0.378,0.573,0.662l-1.182,8.744
    		c-0.054,0.401-0.468,0.662-0.752,0.662h-9.725l-4.639,34.314c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963
    		c-0.401,0-0.611-0.379-0.573-0.662l4.639-34.314h-9.724c-0.401,0-0.611-0.377-0.573-0.662L146.014,4.642z M155.971,12.724
    		c0.285,0,0.627,0.262,0.573,0.662l-4.64,34.313h8.638l4.639-34.313c0.039-0.284,0.351-0.662,0.752-0.662h9.725l1.003-7.42H147.25
    		l-1.003,7.42H155.971z"/>
    	<path class="contact-path" d="M221.782,48.113c0,0,0.338,0.911-0.737,0.911H210.34c-0.275,0-0.502-0.18-0.562-0.43l-2-8.314h-15.718l-4.144,8.309
    		c-0.129,0.258-0.406,0.436-0.682,0.436H176.53c0,0-1.027,0.086-0.492-0.91l23.505-43.72c0.136-0.254,0.42-0.415,0.67-0.415h9.221
    		c0.274,0,0.496,0.184,0.558,0.414L221.782,48.113z M200.483,5.304L177.69,47.699h9.26l4.144-8.308
    		c0.129-0.259,0.406-0.436,0.682-0.436h16.64c0.267,0,0.5,0.172,0.562,0.429l2,8.314h9.263L208.81,5.304H200.483z M206.027,31.536
    		h-9.857c-1.057,0-0.497-0.899-0.497-0.899l6.595-12.718c0.622-1.199,1.236-0.006,1.236-0.006l3.262,12.719
    		C207.021,31.623,206.027,31.536,206.027,31.536z M202.614,19.989l-5.301,10.223h7.923L202.614,19.989z"/>
    	<path class="contact-path" d="M250.037,49.819c-12.681,0-22.956-10.32-21.209-23.238c1.753-12.965,14.775-23.396,27.514-23.396
    		c9.583,0,12.563,2.146,12.681,2.232c0.207,0.154,0.271,0.443,0.184,0.689l-3.445,9.805c-0.022,0.062-0.279,0.881-1.024,0.441
    		c0,0-3.42-2.039-8.363-2.039c-9.643,0-14.653,6.662-15.396,12.162c-0.751,5.555,2.459,12.215,12.101,12.215
    		c4.942,0,8.914-2.039,8.914-2.039c0.061-0.031,0.833-0.454,0.905,0.441l0.794,9.805c0.022,0.271-0.152,0.547-0.362,0.684
    		C263.14,47.698,259.584,49.819,250.037,49.819z M261.631,38.194c-1.49,0.623-4.831,1.82-8.732,1.82
    		c-10.39,0-14.085-7.33-13.246-13.539c0.833-6.158,6.511-13.487,16.9-13.487c3.888,0,6.838,1.161,8.24,1.821l2.986-8.498
    		c-0.955-0.488-4.218-1.803-11.617-1.803c-12.062,0-24.367,9.919-26.01,22.072c-1.636,12.096,8.049,21.913,20.063,21.913
    		c7.366,0,10.964-1.29,12.104-1.803L261.631,38.194z"/>
    	<path class="contact-path" d="M273.796,4.642c0.055-0.4,0.468-0.662,0.752-0.662h30.736c0.401,0,0.611,0.378,0.573,0.662l-1.182,8.744
    		c-0.054,0.401-0.468,0.662-0.752,0.662h-9.725l-4.639,34.314c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963
    		c-0.401,0-0.611-0.379-0.573-0.662l4.639-34.314h-9.724c-0.401,0-0.611-0.377-0.573-0.662L273.796,4.642z M283.753,12.724
    		c0.284,0,0.627,0.262,0.573,0.662l-4.64,34.313h8.638l4.639-34.313c0.039-0.284,0.351-0.662,0.752-0.662h9.725l1.003-7.42h-29.412
    		l-1.003,7.42H283.753z"/>
    </g>
    </svg>

    <div class="contact-form">
      <form  @submit.prevent="submit">
        <label for="name">Name:</label>
        <input
          v-model="name"
          class="inny"
          style="display: block"
          name="name"
          value=""
          required>
        <br>

        <label for="email">Email:</label>
        <input
          v-model="email"
          class="inny"
          style="display: block"
          type="email"
          name="email"
          value=""
          required>
        <br>

        <label for="message">Message:</label>
        <textarea
          v-model="message"
          style="display: block"
          name="message"
          rows="8"
          required>
        </textarea>
        <br>

        <div class="response">
          <p>Thanks! I'll get back to you soon :)</p>
        </div>

        <input class="submit" type="submit" value="Send it">
      </form>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/app';
import 'firebase/firestore';

firebase.initializeApp({
  apiKey: 'AIzaSyAnxuN_-rIE4aLwZYp1pXBy_PzSU7c6vo0',
  authDomain: 'my-portfolio-53d2a.firebaseapp.com',
  projectId: 'my-portfolio-53d2a'
});

let controller = new ScrollMagic.Controller()
export default {
  data() {
    return {
      name: '',
      email: '',
      message: ''
    }
  },
  mounted() {
    let contactTween = TweenMax.to('.contact-container', 1, { opacity:1  });
    let contactScene = new ScrollMagic.Scene({
      triggerElement: ".contact-container",
      triggerHook: "onEnter",
      triggerHook: "0.8",
      reverse: false
    })
    .setTween(contactTween)
    .addTo(controller);
  },
  methods: {
    submit() {
      let db = firebase.firestore();

      // Disable deprecated features
      db.settings({
        timestampsInSnapshots: true
      });
      
      db.collection("messages").add({
        name: this.name,
        email: this.email,
        message: this.message
      })
      .then(function(docRef) {
        // console.log("Document written with ID: ", docRef.id);
        document.getElementsByClassName('submit')[0].style.display = 'none'
        document.getElementsByClassName('response')[0].style.display = 'block'
      })
      .catch(function(error) {
        // console.error("Error adding document: ", error);
      });
    }
  }
}
</script>

<style lang="css">

  .contact-container {
    opacity: 0;
  }

  .contact-form {
    max-width: 400px;
    margin: 0 auto;
    margin-top: 60px;
    margin-bottom: 60px;
  }

  input, textarea {
    width: 100% !important;
    border: 1px solid rgb(140, 140, 140);
    resize: none;
    padding: 3px;
    font-family: 'Crimson Text', serif;
    font-size: 16px;
    background-color: #fff;
  }

  /* Change the white to any color ;) */
  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus, 
  input:-webkit-autofill:active  {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
  }

  .submit {
    margin: 0 auto;
    display: block;
    width: 101% !important;
    height: 30px;
    font-family: 'Crimson Text', serif;
    font-size: 16px;
  }

  .inny {
    height: 20px;
  }

  #Layer_4 {
    display: block;
    max-width: 800px;
    margin-top: 100px;
  }

  .contact-path {
    fill:none;
    stroke:#A8A030;
  }

  .response {
    display: none;
    margin: 0 auto;
    text-align: center;
    color: #A8A030;
  }

  form {
    padding-bottom: 30px;
  }

  /* MOBILE RESPONSIVE */
	@media only screen and (max-width: 700px) {
    .contact-form {
      max-width: 100%;
      margin-top: 46px;
    }

    label {
      font-size: 20px;
    }

    .submit {
      font-size: 18px;
    }
    .contact-container {
      margin-bottom: 30px;
    }

    #Layer_4 {
      max-width: 80%;
      margin-top: 40px;
    }

    input {
      font-size: 16px;
      padding: 3px;
    }
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?7be4ca1c